import { BoundNodeCallbackObservable } from './BoundNodeCallbackObservable';
export var bindNodeCallback = BoundNodeCallbackObservable.create;
//# sourceMappingURL=bindNodeCallback.js.map